import React, { useEffect, useRef } from 'react';
import { Dialog, DialogProps } from 'primereact/dialog';

import './tnk-dialog.scss';

/** Custom event dispatched whenever any TnkDialog is hidden. */
export const TNK_REFRESH_UNREAD_NOTIFICATIONS_EVENT = 'tnk-dialog-hide';

/**
 * Wrapper of PrimeReact Dialog with `focusOnShow={false}` as default.
 * Prevents the close button (X) from being auto-focused on open,
 * which would cause Space key to close the dialog unexpectedly.
 */
type TnkDialogProps = DialogProps & {
  /** Whether to refresh the unread notification count when the dialog closes. Defaults to true. */
  refreshNotifications?: boolean;
};

const TnkDialog: React.FC<TnkDialogProps> = ({
  focusOnShow = false,
  className,
  refreshNotifications = true,
  ...props
}) => {
  const prevVisibleRef = useRef(props.visible);

  // Dispatch event on any close path: both external visible=false and internal onHide (ESC, X button)
  useEffect(() => {
    if (prevVisibleRef.current === true && props.visible === false && refreshNotifications) {
      window.dispatchEvent(new CustomEvent(TNK_REFRESH_UNREAD_NOTIFICATIONS_EVENT));
    }
    prevVisibleRef.current = props.visible;
  }, [props.visible, refreshNotifications]);

  return <Dialog focusOnShow={focusOnShow} className={`tnk-dialog${className ? ` ${className}` : ''}`} {...props} />;
};

export default TnkDialog;
